import { z } from 'zod';

/////////////////////////////////////////
// CORE LOCATION CUSTOM FIELD VALUE TO PICKLIST ITEM SCHEMA
/////////////////////////////////////////

export const CoreLocationCustomFieldValueToPicklistItemSchema = z.object({
  id: z.number().int(),
  coreCustomFieldValueId: z.number().int(),
  corePicklistItemId: z.number().int(),
  rowTimestamp: z.coerce.date(),
})

export type CoreLocationCustomFieldValueToPicklistItem = z.infer<typeof CoreLocationCustomFieldValueToPicklistItemSchema>

export default CoreLocationCustomFieldValueToPicklistItemSchema;
